import { Button } from 'react-aria-components';
import { format } from 'date-fns';
import { ImportProcessInfo } from '@api/import/types/ImportProcessInfo';



interface UploadRunningProps {
	processInfo: ImportProcessInfo,
	reset: () => void,
}


export const UploadRunning = (props: UploadRunningProps) => {
	const { processInfo, reset } = props;

	return (
		<div className='droppable-file-input-info'>
			
			<h1>Nahrávání souboru na serveru už probíhá</h1>

			<p>{`Nahrávání spuštěno: ${processInfo.startTime ? format(processInfo.startTime, 'dd.MM.yyyy HH:mm') : '-'}`}</p>
			
			{processInfo && processInfo.processedItems === 0 && processInfo.totalItems === 0 &&
				<p>{'Probíhá validace souboru'}</p>}

			{processInfo && processInfo.processedItems > 0 && processInfo.totalItems > 0 &&
				<p>{`Zpracováno položek: ${processInfo.processedItems} / ${processInfo.totalItems}`}</p>}

			<Button className="app-highlight-button btn" onPress={reset}>
				Zkusit znovu
			</Button>
		
		</div>
	)
}

export default UploadRunning;